export const Selectors = {
    rotator: '.tx-ig-rotator',
    rotation: '.ig-rotator-rotation'
};